// Auth Types
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const TX_SEND = 'TX_SEND';
export const TX_FAIL = 'TX_FAIL';
export const TX_SUCCESS = 'TX_SUCCESS';
export const TX_CONFIRMATION = 'TX_CONFIRMATION';
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const PRELOADING_START = 'PRELOADING_START';
